/**
 * Pareja · aviso «tu pareja ha apuntado un gasto»: cuándo tiene que avisar
 * esta app al servidor de que acabas de apuntar. Se compara el `sort_order`
 * de tu último apunte (es la hora a la que se creó, en milisegundos) con el
 * último del que ya se avisó, que se guarda en este aparato.
 */

/** Lo apuntado hace más de esto (otro aparato, una importación vieja) no avisa. */
export const RECIENTE_MS = 10 * 60 * 1000;

const PREFIJO = 'rumbo-pareja-avisado:';

export function debeAvisar(
  ultimo: number | null,
  avisado: number | null,
  ahora: number,
): boolean {
  if (ultimo == null || avisado == null) {
    // La primera vez solo se toma nota: lo de antes no avisa.
    return false;
  }
  return ultimo > avisado && ahora - ultimo <= RECIENTE_MS;
}

export function leerAvisado(fileId: string): number | null {
  try {
    const v = window.localStorage.getItem(PREFIJO + fileId);
    return v == null ? null : Number(v) || 0;
  } catch {
    return null;
  }
}

export function guardarAvisado(fileId: string, valor: number) {
  try {
    window.localStorage.setItem(PREFIJO + fileId, String(valor));
  } catch {
    // Sin almacenamiento: sin aviso a la pareja.
  }
}
